import { z } from "zod";

export const PROXY_EXTERNAL_MESSAGE_TYPE = "verity-proxy-external-message";
export const PROXY_BACKGROUND_MESSAGE_TYPE = "verity-proxy-background-message";

const ProxyCorrelatedMessageSchema = z.object({
	id: z.string(),
});

const ProxyExternalMessageBaseSchema = ProxyCorrelatedMessageSchema.extend({
	type: z.literal(PROXY_EXTERNAL_MESSAGE_TYPE),
});
const HandledProxyExternalMessageSchema = ProxyExternalMessageBaseSchema.extend({
	handler: z.string(),
	params: z.any(),
});
const RawProxyExternalMessageSchema = ProxyExternalMessageBaseSchema.extend({
	message: z.any(),
});
export const ProxyExternalMessageSchema = z.union([HandledProxyExternalMessageSchema, RawProxyExternalMessageSchema]);

const ProxyBackgroundMessageBaseSchema = ProxyCorrelatedMessageSchema.extend({
	type: z.literal(PROXY_BACKGROUND_MESSAGE_TYPE),
});
export const ProxyBackgroundMessageSchema = z.discriminatedUnion("success", [
	ProxyBackgroundMessageBaseSchema.extend({
		success: z.literal(true),
		result: z.any(),
	}),
	ProxyBackgroundMessageBaseSchema.extend({
		success: z.literal(false),
		error: z.unknown().optional(),
	}),
]);
